<template>
  <v-container fluid grid-list-md tile>
      <v-layout row wrap>
          <v-flex xs12 md6 v-for="item in (images?images:[])" :key="item.id">
            <v-card
              outlined
            >
              <v-card-title>
                Pending upload
              </v-card-title>
              <v-card-text
                class="d-flex flex-column"
              >
                <v-img
                    class="white--text align-end"
                    contain
                    :src="item"
                />
              </v-card-text>

              <v-card-actions>
                  <v-btn
                  text
                  color="accent"
                  @click.stop="showDeleteDialog=true"
                  v-bind:loading="loading"
                  ><v-icon>{{ icons.delete }}</v-icon>
                  </v-btn>
              </v-card-actions>
            </v-card>
            <DeleteDialog title="Are you sure to delete?" :data="{file:item}" :visible="showDeleteDialog" @close="showDeleteDialog=false" @confirmAction="deletingImage"/>
          </v-flex>
      </v-layout>
  </v-container>
</template>
<script>
import DeleteDialog from '@/components/ConfirmDeleteDialog.vue'
import { mdiDelete } from '@mdi/js'

export default {
  data () {
    return {
      isLoaded: false,
      icons: {
        delete: mdiDelete
      },
      showDeleteDialog: false,
      loading: false
    }
  },
  components: {
    DeleteDialog
  },

  props: {
    images: {
      type: Array,
      default: null,
      required: true
    },
    id: {
      type: Number,
      default: -1
    }
  },
  methods: {

    imageLoaded () {
      this.$log.info('Image loaded')
      this.isLoaded = true
    },
    deletingImage (data) {
      this.$emit('delete_success', { file: data.file })
    }
  }
}
</script>
